import { render, staticRenderFns } from "./SurrenderVerification.vue?vue&type=template&id=1aa8470f&"
import script from "./SurrenderVerification.vue?vue&type=script&lang=js&"
export * from "./SurrenderVerification.vue?vue&type=script&lang=js&"
import style0 from "./SurrenderVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports